import { Howl, Howler } from 'howler'

let sounds: { ok: Howl; alarm: Howl; check: Howl } | null = null

type AudioContextCtor = typeof window.AudioContext

function getAudioContextCtor(): AudioContextCtor | undefined {
    return window.AudioContext ?? (window as unknown as { webkitAudioContext?: AudioContextCtor }).webkitAudioContext
}

function unlockAudioContext() {
    const Ctx = getAudioContextCtor()
    if (Ctx) {
        const ctx = new Ctx()
        if (ctx.state !== 'running') {
            void ctx.resume()
        }
    }
}

export function isAudioContextRunning(): boolean {
    const Ctx = getAudioContextCtor()
    if (!Ctx) return true
    const ctx = new Ctx()
    return ctx.state === 'running'
}

export function initSound() {
    unlockAudioContext()
    if (sounds) return sounds

    const base = `${import.meta.env.BASE_URL}`
    sounds = {
        ok: new Howl({ src: [base + 'sound-ok.mp3'] }),
        alarm: new Howl({ src: [base + 'sound-alarm.mp3'] }),
        check: new Howl({ src: [base + 'sound-check.mp3'] })
    }
    Howler.volume(1.0)
    return sounds
}

export function playOk() {
    if (sounds?.ok) sounds.ok.play()
}

export function playAlarm() {
    if (sounds?.alarm) sounds.alarm.play()
}

export function playCheck() {
    if (sounds?.check) sounds.check.play()
}
